import useImageResizer from './imageResizer';

export * from './imageResizer';

export default useImageResizer;
